import { z } from "zod";
export const memoryRolloutModeSchema = z.enum([
    "disabled",
    "shadow",
    "active_intentional",
]);
export const DISABLED_MEMORY_ROLLOUT_MODE = "disabled";
const MEMORY_ROLLOUT_RANK = Object.freeze({
    disabled: 0,
    shadow: 1,
    active_intentional: 2,
});
/** Returns the least-permissive mode. No caller can use this to widen a mode. */
export function narrowMemoryRolloutMode(...modes) {
    if (modes.length === 0)
        return DISABLED_MEMORY_ROLLOUT_MODE;
    return modes.reduce((narrowest, mode) => MEMORY_ROLLOUT_RANK[mode] < MEMORY_ROLLOUT_RANK[narrowest]
        ? mode
        : narrowest);
}
export const memoryRunPolicySchema = z.object({
    read: z.boolean(),
    publishEpisodes: z.boolean(),
    proposeIntentionalMemories: z.boolean(),
}).strict();
export const INTERACTIVE_MEMORY_RUN_POLICY = Object.freeze({
    read: true,
    publishEpisodes: true,
    proposeIntentionalMemories: true,
});
export const UNATTENDED_MEMORY_RUN_POLICY = Object.freeze({
    read: true,
    publishEpisodes: false,
    proposeIntentionalMemories: false,
});
export const MEMORY_TRANSPORT_PROTOCOL_VERSION = 1;
export const memoryTransportProtocolVersionSchema = z.literal(MEMORY_TRANSPORT_PROTOCOL_VERSION);
